import { createRoot } from "react-dom/client";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/auth";

const root = createRoot(document.getElementById("root"));
root.render(
    <HelmetProvider>
        <BrowserRouter basename="/">
            <AuthProvider>
                <App />
            </AuthProvider>
        </BrowserRouter>
    </HelmetProvider>
);